module.exports = __webpack_public_path__ + "static/media/classicos_masculino_fitness.b7d99db0.jpg";